import React from 'react';

import styles from './PromoProgressBar.module.css';

interface PromoProgressBarProps {
    startTime: string;
    endTime: string;
    currentTimestamp: number;
}

export const PromoProgressBar: React.FC<PromoProgressBarProps> = (props) => {
    const { currentTimestamp, startTime, endTime } = props;

    const start = new Date(startTime).getTime();
    const end = new Date(endTime).getTime();

    const total = end - start;
    const elapsed = currentTimestamp - start;
    const progress = total > 0 ? Math.min(Math.max(elapsed / total, 0), 1) : 0;

    return (
        <div className={styles.root}>
            <div className={styles.line} style={{ transform: `scaleX(${progress})` }} />
        </div>
    );
};
